export class AdminAccountModel {
  accountId: string = '';

  constructor(accountId: string) {
    this.accountId = accountId;
  }
}